module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_01.a72b5a7f.svg";